export const shadowSize = {
  border: 'inset 0px 0px 0px 1px',
  '100': '0px 4px 8px -6px',
  '200': '0px 4px 12px -6px',
  '300': '0px 4px 22px -10px',
  '400': '0px 6px 28px -12px',
};
